import {HStack, Icon, Show, Text, VStack} from 'platform/foundation';

import {isNil} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import {CustomerAdvancedSearchResultContactResponseBody} from '@dms/api/customer';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

import {useAddress} from '../../../hooks/useAddress';
import {getNaturalPersonFullName} from '../../../utils/getNaturalPersonFullName';
import {joinInfoLine} from '../utils/joinInfoLine';

interface RowPrimaryContactProps {
  contact: CustomerAdvancedSearchResultContactResponseBody | Nullish;
}

export function RowPrimaryContact(props: RowPrimaryContactProps) {
  const {composeAddress} = useAddress();

  if (isNil(props.contact)) {
    return null;
  }

  const name = getNaturalPersonFullName(props.contact);
  const infoLine = joinInfoLine([
    props.contact.phone,
    props.contact.email,
    composeAddress(props.contact.address),
  ]);

  if (!isNotNilOrEmpty(name) && !isNotNilOrEmpty(infoLine)) {
    return null;
  }

  const label = i18n.t('entity.customer.labels.contactPersonsHelperText');

  return (
    <VStack spacing={0}>
      <HStack spacing={1} align="center">
        <Icon value="social/person" size={3} color="text.tertiary" />
        <Text size="xSmall" color="tertiary" noWrap>
          {isNotNilOrEmpty(name) ? `${label}: ${name}` : label}
        </Text>
      </HStack>
      <Show when={isNotNilOrEmpty(infoLine)}>
        <Text size="xSmall" color="tertiary">
          {infoLine}
        </Text>
      </Show>
    </VStack>
  );
}
